import { useParams } from 'react-router-dom';
import CategoryPage from '@/pages/category/page';
import SiteLayout from '@/components/feature/SiteLayout';
import EmptyState from '@/components/base/EmptyState';
import type { FilmType } from '@/mocks/films';

export default function CategoryRoute() {
  const { type } = useParams<{ type: string }>();

  if (type !== 'movie' && type !== 'tv') {
    return (
      <SiteLayout>
        <div className="px-4 py-10 md:px-8 lg:px-12">
          <EmptyState
            title="分类不存在"
            description="只支持电影与电视剧两个分类，返回首页重新选择吧。"
            resetLabel="返回首页"
            resetTo="/"
          />
        </div>
      </SiteLayout>
    );
  }

  return (
    <SiteLayout>
      <CategoryPage type={type as FilmType} />
    </SiteLayout>
  );
}